import React, { useCallback, useMemo } from 'react';
import {
  BlockRow,
  LocationText,
  ScheduleAndLocationBlockContainer,
  ScheduleText
} from './styled';
import ScheduleIcon from '../../../../public/static/images/item/schedule.svg';
import LocationIcon from '../../../../public/static/images/item/location.svg';
import { Icon } from '../../../Icon';
import { useGoogleMaps } from '../../../../providers/GoogleMapsProvider';

interface ScheduleAndLocationBlockProps {
  schedule?: string | null;
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  city?: string | null;
  dataStat?: string;
}

export const ScheduleAndLocationBlock: React.FC<
  ScheduleAndLocationBlockProps
> = ({
  schedule,
  address,
  latitude,
  longitude,
  city,
  dataStat = 'agency-address'
}) => {
  const { setIsInitializedMap, toggleModal, setMapData, setMapModalData } =
    useGoogleMaps();
  const coordinates = useMemo(() => {
    if (!latitude || !longitude) return undefined;
    return { lat: latitude, lng: longitude };
  }, [latitude, longitude]);
  const preparedAddress = [city, address].filter(Boolean).join(', ');

  const onClick = useCallback(() => {
    setMapData({
      initialLocation: coordinates,
      isMarkerDraggable: false
    });
    setMapModalData({
      modalId: 'schedule-location-map-modal'
    });
    setIsInitializedMap(true);
    toggleModal();
  }, [
    coordinates,
    setIsInitializedMap,
    toggleModal,
    setMapData,
    setMapModalData
  ]);

  return (
    <ScheduleAndLocationBlockContainer>
      <BlockRow>
        <Icon
          indent={false}
          height={18}
          width={18}
          IconComponent={ScheduleIcon}
        />
        <ScheduleText tag="body_3">{schedule}</ScheduleText>
      </BlockRow>

      <BlockRow>
        <Icon
          indent={false}
          height={18}
          width={15}
          IconComponent={LocationIcon}
        />
        <LocationText
          tag="body_3"
          onClick={coordinates ? onClick : undefined}
          data-stat={dataStat}
          $isCoordinates={!!coordinates}
        >
          {preparedAddress}
        </LocationText>
      </BlockRow>
    </ScheduleAndLocationBlockContainer>
  );
};
